import { z } from 'zod';

export const positioningAIGenerateSchema = z.object({
  company_description: z
    .string()
    .min(10, 'Company description must be at least 10 characters')
    .regex(/^[a-zA-Z0-9\s.,;:!?'"()&-]+$/, 'Only alphanumeric characters and common punctuation are allowed')
    .optional()
    .or(z.literal('')),
  competitor: z
    .string()
    .min(3, 'Competitor must be at least 3 characters')
    .regex(/^[a-zA-Z0-9\s,&-]+$/, 'Only alphanumeric characters, commas, and hyphens are allowed')
    .optional()
    .or(z.literal('')),
  unique_value: z
    .string()
    .min(5, 'Unique value must be at least 5 characters')
    .refine(val => val === '' || /[a-zA-Z]/.test(val), {
      message: 'Must contain at least some text, not just numbers or symbols',
    })
    .optional()
    .or(z.literal('')),
  target_audience: z
    .string()
    .min(5, 'Target audience must be at least 5 characters')
    .refine(val => val === '' || val.trim().length > 0, {
      message: 'Cannot be just spaces',
    })
    .optional()
    .or(z.literal('')),
});

export type PositioningAIGenerateFormData = z.infer<typeof positioningAIGenerateSchema>;
